module.exports = __webpack_public_path__ + "static/img/dbbj.640354d2.png";